// extracted by mini-css-extract-plugin
export default {"footer":"AFooter_footer__Ls-kn","allRights":"AFooter_allRights__3ELBL"};